// extracted by mini-css-extract-plugin
export var animationContainer = "_ie-0";
export var asteriskIcon = "_ie-8";
export var conversationLeftSection = "_ie-4";
export var conversationListItem = "_ie-3";
export var conversationMiddleSection = "_ie-5";
export var conversationRightSection = "_ie-6";
export var detailsContent = "_ie-1";
export var listContainer = "_ie-7";
export var modalContent = "_ie-2";